import { Message } from 'element-ui'

export default {
  install(Vue) {
    Vue.prototype.$toast = (content, duration = 3000) => {
      Message({
        message: content,
        iconClass: '',
        customClass: 'win-toast',
        type: null,
        duration: duration
      })
    }
  }
}
